module.exports = __webpack_public_path__ + "img/logo.8b6471d5.svg";